let locks = 0
let previousOverflow = ''

/**
 * Запрещает прокрутку страницы под модальным слоем. Замки считаются:
 * лайтбокс поверх панели деталей не должен снимать её замок при закрытии,
 * а при размонтировании обоих порядок cleanup-эффектов не важен.
 */
export function lockBodyScroll(): () => void {
  if (locks === 0) {
    previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
  }
  locks += 1
  let released = false
  return () => {
    if (released) return
    released = true
    locks -= 1
    if (locks === 0) document.body.style.overflow = previousOverflow
  }
}
